export default __webpack_public_path__ + "static/media/shopping-bag.fac04be9.png";